/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Video_Requires_MixdownInputs */

const en_audio_description_export_video_requires_mixdown = /** @type {(inputs: Audio_Description_Export_Video_Requires_MixdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requires Export Mixdown to be enabled`)
};

const fr_audio_description_export_video_requires_mixdown = /** @type {(inputs: Audio_Description_Export_Video_Requires_MixdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nécessite l'export du mixdown`)
};

const de_audio_description_export_video_requires_mixdown = /** @type {(inputs: Audio_Description_Export_Video_Requires_MixdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erfordert, dass Export Mixdown aktiviert ist.`)
};

const it_audio_description_export_video_requires_mixdown = /** @type {(inputs: Audio_Description_Export_Video_Requires_MixdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Richiede che Export Mixdown sia abilitato`)
};

const ru_audio_description_export_video_requires_mixdown = /** @type {(inputs: Audio_Description_Export_Video_Requires_MixdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для корректной работы требуется включить функцию Export Mixdown.`)
};

const es_audio_description_export_video_requires_mixdown = /** @type {(inputs: Audio_Description_Export_Video_Requires_MixdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requiere que Export Mixdown esté habilitado`)
};

const zh_cn2_audio_description_export_video_requires_mixdown = /** @type {(inputs: Audio_Description_Export_Video_Requires_MixdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`需要启用导出混音功能`)
};

const ja_audio_description_export_video_requires_mixdown = /** @type {(inputs: Audio_Description_Export_Video_Requires_MixdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エクスポートミックスダウンを有効にする必要があります`)
};

const hi_audio_description_export_video_requires_mixdown = /** @type {(inputs: Audio_Description_Export_Video_Requires_MixdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक्सपोर्ट मिक्सडाउन को सक्षम करना आवश्यक है`)
};

const pt_pt2_audio_description_export_video_requires_mixdown = /** @type {(inputs: Audio_Description_Export_Video_Requires_MixdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requer que a opção Export Mixdown esteja ativada.`)
};

/**
* | output |
* | --- |
* | "Requires Export Mixdown to be enabled" |
*
* @param {Audio_Description_Export_Video_Requires_MixdownInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_video_requires_mixdown = /** @type {((inputs?: Audio_Description_Export_Video_Requires_MixdownInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Video_Requires_MixdownInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_video_requires_mixdown(inputs)
	if (locale === "de") return de_audio_description_export_video_requires_mixdown(inputs)
	if (locale === "it") return it_audio_description_export_video_requires_mixdown(inputs)
	if (locale === "ru") return ru_audio_description_export_video_requires_mixdown(inputs)
	if (locale === "es") return es_audio_description_export_video_requires_mixdown(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_video_requires_mixdown(inputs)
	if (locale === "ja") return ja_audio_description_export_video_requires_mixdown(inputs)
	if (locale === "hi") return hi_audio_description_export_video_requires_mixdown(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_video_requires_mixdown(inputs)
	return en_audio_description_export_video_requires_mixdown(inputs)
});